import { render, staticRenderFns } from "./temporary-registration-dialog.vue?vue&type=template&id=2e3712de&scoped=true&"
import script from "./temporary-registration-dialog.vue?vue&type=script&lang=js&"
export * from "./temporary-registration-dialog.vue?vue&type=script&lang=js&"
import style0 from "./temporary-registration-dialog.vue?vue&type=style&index=0&id=2e3712de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3712de",
  null
  
)

export default component.exports